export default {
    namespaced: true,
    state: {
        my_name: '亿梦电子版',
        term_softs: [
            '亿梦电子版',
        ],
        fen_softs: [
        ]
    }
}